<template>
<PattanButton :states="buttonStates" :startState="this.isRegistered ? 1 : 0" />
</template>

<script>
import * as authPopup from '@/auth/authPopup'
import {callApi} from "@/shared/ApiHelper"
import PattanButton from '@/components/PattanButton'
import {useApiStore} from "@/store/api.js"

export default {
    name: 'SessionButton',

    components: {
        PattanButton,
    },

    emits: [
        'sessionAdded',    
        'sessionRemoved',
    ],

    mounted() {
        const accounts = authPopup.msalAgent.getAllAccounts()
        if (1 > accounts.length) {
            this.buttonStates[0].onClick = authPopup.signIn
            this.buttonStates[1].onClick = authPopup.signIn
        }
    },

    data() {
        return {
            apiStore: useApiStore(),
            buttonStates: [
                {
                    label: 'Add session',
                    color: 'var(--phoenix-link-color)',
                    onClick: this.addButtonClickHandler,
                },
                {
                    label: 'Remove session',
                    color: 'var(--phoenix-900)',
                    onClick: this.removeButtonClickHandler,
                },
            ],
        }
    },

    methods: {
        async addButtonClickHandler() {
            let response = await callApi(this.apiStore.buildUrl('/events/attendees/'), 'PUT', {'session_id': this.sessionId})
            let isGood = 200 <= response.status && 202 >= response.status
            if (isGood) {
                this.$emit('sessionAdded', this.sessionId)
            }
            return isGood
        },
        
        async removeButtonClickHandler() {
            let response = await callApi(this.apiStore.buildUrl('/events/attendees/?action=remove'), 'PUT', {'session_id': this.sessionId})
            let isGood = 200 <= response.status && 202 >= response.status
            if (isGood) {
                this.$emit('sessionRemoved', this.sessionId)
            }
            return isGood
        },
    },

    props: {
        isRegistered: Boolean,
        sessionId: Number,
    }
}
</script>